import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';

import {FormattedMessage, useIntl} from 'react-intl';

import {IStore} from 'redux/interface';
import {
  cmServiceAsyncActions,
  getCmServicesOrg,
  getTranslations
} from 'redux/pageAsyncActions';
import {useGetTranslations} from 'utils/hooks/useGetTranslations';
import {TranslationKeys} from 'utils/constants/routeConstants';

import NotFoundImg from 'assets/image/common/notFound.png';

import NotFoundInfo from 'components/not-found-info';
import {maxServiceCards} from '../../utils/constants/constants';
import CmCardSection from '../../components/cm-card-section';
import {Link, useNavigate, useParams} from 'react-router-dom';
import {CmServiceFilterType} from '../../components/cm-filters/CmFilterEnums';

import './styles.scss';

export const CmResourceOrganization: React.FunctionComponent = () => {
  const {
    servicesOrg,
    pageOrg
  } = useSelector((state: IStore) => state.cm_service);
  const {
    loading
  } = useSelector((state: IStore) => state.status);
  const dispatch = useDispatch();
  const intl = useIntl();
  const history = useNavigate();
  const {orgId} = useParams();
  const [orgName, setOrgName] = useState<string>();

  useGetTranslations({
    translationKey: TranslationKeys.CmResource
  });

  function loadService(offset: number) {
    dispatch(cmServiceAsyncActions[getCmServicesOrg](
      {
        filter: [{
          name: CmServiceFilterType.cmOrganizations,
          inputValue: `${orgId}`
        }],
        offset,
        limit: maxServiceCards
      }
    ));
  }

  useEffect(() => {
    loadService(0);
  }, []);

  useEffect(() => {
    if (servicesOrg && servicesOrg.length) {
      setOrgName(servicesOrg[0].orgName);
    }
  }, [servicesOrg]);

  function handleLoadMore(offset: number) {
    loadService(offset);
  }

  function handleOpenCard(srvId: number) {
    history(`/cmresource/${srvId}`);
  }

  function renderBreadcrumbs() {
    return <div className="cm-resource-org__breadcrumbs">
      <Link className="cm-resource-org__breadcrumbs__previous" to={'/cmresource'}>
        <FormattedMessage
          id={'gritx.cmresource.breadcrumb.previous'}
          defaultMessage='Resources'
        />
      </Link>{orgName && <span className="cm-resource-org__title-org-name"> - {orgName}</span>}
    </div>;
  }

  return <section className={'cm-resource-org container'}>
    {
      !loading.includes(getTranslations) && <>
        {renderBreadcrumbs()}
        <div className="cm-resource-org__cards">
          {servicesOrg.length === 0 && !loading.includes(getCmServicesOrg) ? <NotFoundInfo
            title={intl.formatMessage({
              id: 'gritx.cmresource.org.sectionCards.notFound',
              defaultMessage: 'Sorry, but nothing can be found.'
            })}
            image={NotFoundImg}
          /> : pageOrg && <CmCardSection
            showLoader={loading.includes(getCmServicesOrg)}
            cards={servicesOrg}
            onLoadMore={handleLoadMore}
            onClickCard={handleOpenCard}
            page={pageOrg}
          />}
        </div>
      </>
    }
  </section>;
};
